import { useState } from 'react';
import { Button } from '../button/Button';
import { moderatorRuling } from '../../api/witness';
import type { ModPendingReport } from '../../api/useGameEvents';
import styles from './Witness.module.css';

type Props = {
  code: string;
  moderatorName: string;
  reports: ModPendingReport[];
};

export function ModIncidentPanel({ code, moderatorName, reports }: Props) {
  const [submitting, setSubmitting] = useState<number | null>(null);

  if (reports.length === 0) return null;

  const rule = async (reportId: number, ruling: 'arrest' | 'confirm_kill' | 'dismiss') => {
    setSubmitting(reportId);
    try {
      await moderatorRuling(code, moderatorName, reportId, ruling);
    } catch (err) {
      alert(err instanceof Error ? err.message : 'Ruling failed');
    } finally {
      setSubmitting(null);
    }
  };

  return (
    <div className={styles.incidentPanel}>
      <p className={styles.incidentTitle}>Pending incidents ({reports.length})</p>
      {reports.map((r) => (
        <div key={r.reportId} className={styles.incidentItem}>
          <p className={styles.incidentDesc}>
            <strong>{r.killerName ?? '?'}</strong> accused of murdering{' '}
            <strong>{r.victimName ?? '?'}</strong>
            {r.weaponName ? (
              <>
                {' '}
                with <strong>{r.weaponName}</strong>
              </>
            ) : null}
          </p>
          <p className={styles.incidentReason}>Killer says: &ldquo;{r.killerReason}&rdquo;</p>
          <div className={styles.incidentActions}>
            <Button onClick={() => rule(r.reportId, 'arrest')} disabled={submitting === r.reportId}>
              Arrest
            </Button>
            <Button
              variant="secondary"
              onClick={() => rule(r.reportId, 'confirm_kill')}
              disabled={submitting === r.reportId}
            >
              Confirm kill
            </Button>
            <Button
              variant="secondary"
              onClick={() => rule(r.reportId, 'dismiss')}
              disabled={submitting === r.reportId}
            >
              Dismiss
            </Button>
          </div>
        </div>
      ))}
    </div>
  );
}
